module.exports = __webpack_public_path__ + "img/arrowDown.c20ce3c5.svg";